/**
 * Escape one cell for CSV.
 *
 * This used to be a plain `join(',')`, which silently corrupted any row
 * containing a comma — a company name like "Acme, Ltd" became two columns
 * and shifted every field after it, in a file nobody re-opens to check.
 * Quotes inside a value are doubled, per RFC 4180.
 */
const cell = (v: string | number | null | undefined): string => {
  const s = v === null || v === undefined ? '' : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function exportToCsv(
  filename: string,
  headers: string[],
  rows: (string | number | null | undefined)[][],
): void {
  const csv = [headers, ...rows].map((r) => r.map(cell).join(',')).join('\r\n');

  // Excel assumes the system codepage unless a UTF-8 BOM says otherwise,
  // which is what turns names with accents into mojibake on open.
  const blob = new Blob(['﻿' + csv], {
    type: 'text/csv;charset=utf-8;',
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
